<template>

</template>
<script>


export default {
    beforeMount() {
        this.$store.commit("clearAuthCredentials");
    }
};
</script>
